import React from 'react';
/**
 * `RenewalsFailedRegistration` renders the payment/registration failure page
 * for the renewals journey.
 *
 * It displays the failure reason from journey state and provides a
 * `ReloadHandler` that returns the user to the renewals landing page.
 */
import { PageAbsolutePath } from '../../../consts/Common';
import ReloadHandler from '../../common/ReloadHandler';
import { useJourney } from '../Layout';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../app-state/Hooks';

const RenewalsFailedRegistration = (): JSX.Element => {
  const { t } = useTranslation();
  const { journey } = useJourney();
  const { registrationFailMsg } = journey;

  const supportPhone =
    useAppSelector((s) => s.content.failedRegistration?.phone) ||
    '0344 573 8002';

  return (
    <div>
      <h3>{t('confirmation.purchase-not-completed-message')}</h3>
      <p className='p2 m1-bottom'>{registrationFailMsg}</p>
      <p className='p2'>
        {t('confirmation.contact-us-message', { phone: supportPhone })}
      </p>
      <ReloadHandler reloadPath={PageAbsolutePath.Renewals.Landing} />
    </div>
  );
};

export default RenewalsFailedRegistration;
